import { createContext, useContext, type ReactNode } from "react";
import type { FtmDataService } from "../services/ftmDataProvider";

const FtmDataServiceContext = createContext<FtmDataService | null>(null);

export function FtmDataServiceProvider({ service, children }: { service: FtmDataService; children: ReactNode }) {
  return <FtmDataServiceContext.Provider value={service}>{children}</FtmDataServiceContext.Provider>;
}

export function useFtmDataService(): FtmDataService {
  const service = useContext(FtmDataServiceContext);
  if (!service) throw new Error("useFtmDataService must be used inside FtmDataServiceProvider");
  return service;
}
